module.exports = __webpack_public_path__ + "static/img/1.013f577.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/sp/1.png
// module id = MXtx
// module chunks = 0